function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.06 1.06a1.495 1.495 0 012.115-.006L20.16 18.038a1.491 1.491 0 01-.007 2.115 1.495 1.495 0 01-2.115.007L1.054 3.175a1.491 1.491 0 01.007-2.114z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.153 1.06a1.495 1.495 0 00-2.115-.006L1.054 18.038a1.491 1.491 0 00.007 2.115 1.495 1.495 0 002.114.007L20.16 3.175a1.491 1.491 0 00-.007-2.114z"
}));

function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21"
  }, props), _ref);
}

export default SvgCancel;